import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';

const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.space[2]}px;
`;

const Tag = styled.span`
  font-size: ${theme.fontSizes.xs};
  color: ${theme.colors.accent};
  background: ${theme.colors.accentSoft};
  padding: 4px 12px;
  border-radius: ${theme.radii.pill}px;
`;

export function TagList({ tags }) {
  if (!tags?.length) return null;

  return (
    <List>
      {tags.map((tag) => (
        <Tag key={tag}>{tag}</Tag>
      ))}
    </List>
  );
}
